
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../../application/common/components/header/header.component';
import { SidebarComponent } from '../../../application/common/components/sidebar/sidebar.component';
import { LayoutService } from '../../../application/common/services/layout.service';
@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, HeaderComponent],
  templateUrl: './app-shell.component.html',
})
export class AppShellComponent {
  constructor(public layout: LayoutService) {}
}
